import { request } from '@/shared/api'
import Mixins from '@/base/mixins'

/*
 global document, FormData, epi, window
*/
export default class EpiserverForm extends Mixins {
  constructor() {
    super()
    this.initElems()
    this.initHandlers()
  }

  initElems() {
    this.buttons = document.querySelectorAll('.EPiServerForms .FormSubmitButton')
    this.checkboxes = document.querySelectorAll('.EPiServerForms .FormChoice__Input--Checkbox')

    this.modalButtons = document.querySelectorAll('.js-epi-modal-btn')
    this.closeModalButtons = document.querySelectorAll('.js-epi-modal__close')
    this.body = document.querySelector('body')
  }

  initHandlers() {
    if (this.buttons) {
      this.buttons.forEach((button) => {
        button.addEventListener('click', this.submitForm.bind(this))
      })
    }

    if (this.checkboxes) {
      this.checkboxes.forEach((checkbox) => {
        checkbox.addEventListener('keyup', this.triggerClickByEnter)
      })
    }

    if (this.modalButtons) {
      this.modalButtons.forEach((button) => {
        button.addEventListener('click', this.openModal.bind(this))
      })
    }

    if (this.closeModalButtons) {
      this.closeModalButtons.forEach((button) => {
        button.addEventListener('click', this.closeModal.bind(this))
      })
    }

    document.querySelector('body').addEventListener('click', (e) => {
      // close modal by outside click
      const openModal = document.querySelector('.cta__step-2--open')

      if (!e.target.closest('.cta__modal-dialog') && openModal) {
        openModal.closest('.js-epi-modal').classList.remove('cta__step-2--open')
        this.body.classList.remove('lock-scroll')
      }
    }, false)
  }

  runValidation(form) {
    let isFormValid = true
    const inputs = form.querySelectorAll('.FormTextbox__Input, .FormChoice__Input--Checkbox')

    inputs.forEach((elem) => {
      let isElemValid = true
      const { name } = elem
      const val = elem.type === 'checkbox' ? (elem.checked ? 'checked' : false) : elem.value
      const validators = epi.EPiServer.Forms.Validation.getElementValidators(epi.EPiServer.Forms[form.id].ValidationInfo, name)

      const res = epi.EPiServer.Forms.Validation.validateFormValue(name, val, validators)

      res.forEach((item) => {
        const invalidElement = form.querySelector(`#${item.fieldName}_desc`)

        if (!item.isValid) {
          invalidElement.innerHTML = item.message
          invalidElement.removeAttribute('style')

          isElemValid = false
          isFormValid = false
        }

        if (isElemValid) {
          invalidElement.innerHTML = ''
          invalidElement.style.display = ('none')
        }
      })
    })

    return isFormValid
  }

  openModal(e) {
    e.stopPropagation()

    const modal = e.target.closest('.js-cta').querySelector('.js-epi-modal')
    modal.classList.add('cta__step-2--open')

    this.body.classList.add('lock-scroll')
  }

  closeModal(e) {
    const modal = e.target.closest('.js-epi-modal')
    modal.classList.remove('cta__step-2--open')

    this.body.classList.remove('lock-scroll')
  }

  submitForm(e) {
    e.preventDefault()
    e.stopImmediatePropagation()

    const form = e.target.closest('form')
    const data = new FormData(form)
    const isDownloadForm = e.target.closest('.cta__download')
    const buttonSubmit = document.querySelector('.Form__Element .FormSubmitButton')

    if (this.runValidation(form)) {
      if (buttonSubmit) {
        buttonSubmit.disabled = true
      }

      request('post', 'EPiServer.Forms/DataSubmit/Submit', data)
        .then((response) => {
          if (response.status === 200) {
            if (response.data.isSuccess) {
              // Push GTM event
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({ event: 'formSubmission' })

              const { redirectUrl } = response.data
              if (redirectUrl) {
                if (isDownloadForm) {
                  window.open(redirectUrl, '_blank')
                  return
                }

                window.location = redirectUrl
              }

              if (response.data.message) {
                form.innerHTML = response.data.message
                this.hideElements(form)
                return
              }
            }

            if (buttonSubmit) {
              buttonSubmit.disabled = false
            }
          }
        })
    }
  }

  hideElements(form) {
    const parent = form.closest('.js-cta')
    const elems = parent.querySelectorAll('.js-hide-elem')

    elems.forEach((elem) => { elem.style.display = 'none' })
  }
}
